import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * What a screen shows before it has anything to show. It states the situation,
 * says what the screen would do once there is data, and offers the one action
 * that gets there - an empty box with the word "empty" in it helps nobody.
 */
export function EmptyState({
  icon: Icon,
  title,
  body,
  action,
}: {
  icon: LucideIcon;
  title: string;
  body?: string;
  action?: ReactNode;
}) {
  return (
    <div className="crm-empty">
      <div className="crm-empty-mark">
        <Icon className="size-7" strokeWidth={1.7} />
      </div>
      <h3>{title}</h3>
      {body ? <p>{body}</p> : null}
      {action ? <div className="flex justify-center">{action}</div> : null}
    </div>
  );
}
